import React from 'react';
import Analytics from './Analytics';
import { useNavigate } from 'react-router-dom';

export const AnalyticsPage = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate(-1); // Go back to previous page
    };

    return (
        <div className="page-container">
            <Analytics isVisible={true} onClose={handleClose} />
        </div>
    );
};

export default AnalyticsPage;
